// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3nzwL","label":"Completed_label__v_1T3"};